import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { compose } from 'redux';
import FramePage from 'components/framePage/FramePage';

export interface IScreenErrorOfflineProps extends WithTranslation {
}

export interface IScreenErrorOfflineState {
}

class ErrorOffline extends React.Component<IScreenErrorOfflineProps, IScreenErrorOfflineState> {
    static displayName: string = 'ErrorOffline';

    render () {
        return (
            <FramePage
                title={this.props.t('sections.about')}
            >
                <React.Fragment>
                    <h1>{this.props.t('sections.about')}</h1>
                    <p>Hello</p>
                </React.Fragment>
            </FramePage>
        );
    }
}

export default compose<any>(
    withTranslation()
)(ErrorOffline);
